module.exports = __webpack_public_path__ + "static/media/partner-logo10.cc7efb4a.png";